export function pickLabel(label, locale) {
  if (label == null) return "";
  if (typeof label === "string") return label;
  if (typeof label !== "object") return String(label);

  const candidates = [locale, "ru", "kk", "kz", "en"];
  for (const key of candidates) {
    if (key && typeof label[key] === "string" && label[key]) return label[key];
  }
  for (const key of Object.keys(label)) {
    if (typeof label[key] === "string" && label[key]) return label[key];
  }
  return "";
}
